import { Typography, TypographyProps } from './Typography';
import { TypographyBold } from './TypographyBold';

const BOLD_PART_REGEX = /\*\*(.+?)\*\*/g;

type Props = {
  text: string;
} & TypographyProps;

export const TypographyWithBold: React.FC<Props> = ({ text, ...rest }) => (
  <Typography variant="body2" {...rest}>
    {text.split(BOLD_PART_REGEX).map((part, index) => {
      const isBoldPart = index % 2 === 1;

      return isBoldPart ? <TypographyBold key={`${index}-${part}`} text={part} /> : part;
    })}
  </Typography>
);
